const initialState = {

  images: [
    {
      imageUrl: "",
    },
  ],
};

export const bookclinicReducer = (state = initialState, action: any) => {
  switch (action.type) {
    case "SET_CLINIC_DATA":
      return {
        ...state,
        ...action.payload,
      };

    default:
      return state;
  }
};
